import OfertaCreate from './OfertaCreate.vue'

export default OfertaCreate

